module.exports = __webpack_public_path__ + "static/media/Background_9.341da41f.svg";